import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        padding: {xs: '1rem 0.5rem', lg: '2ren'}
    }
}